import CategoryFilters from '@c/filters/CategoryFilters';
import { CloseIcon } from '@c/icons';
import Button from '@ui/Button';
import { CategoryDocument } from '@models/category';
import { PageSideFilters, TopFilters } from '@util/hooks/useProductsPage';
import BaseModal from '@c/modals/BaseModal';
import { SetStateAction, Dispatch, useState } from 'react';
import { FacetCounts } from 'models/product';

interface ProductFilterDrawerProps {
  categories: CategoryDocument[];
  allBrands: string[];
  open: boolean;
  dismiss: () => void;
  initialFilters: PageSideFilters;
  onFiltersChange: (filters: PageSideFilters) => void;
  currentCategory: CategoryDocument | null;
  facet_counts?: FacetCounts;
  handleReset: () => void;
}

const ProductFilterDrawer = ({
  categories,
  allBrands,
  open,
  dismiss,
  initialFilters,
  onFiltersChange,
  facet_counts,
  handleReset,
}: ProductFilterDrawerProps) => {
  const [potentialFilterChanges, setPotentialFilterChanges] =
    useState<any>(initialFilters);

  const handleResetFilters = () => {
    handleReset();
    setPotentialFilterChanges(initialFilters);
    dismiss();
  };

  return (
    <div
      className={`${
        open ? 'fixed inset-0' : 'hidden'
      } z-50 h-screen w-full overflow-hidden`}
    >
      <BaseModal isFullScreen dismiss={dismiss} isOpen={open} hideCloseIcon>
        <div className="flex flex-col p-8 pb-[6rem]">
          <div className="flex h-[6.8rem] w-full items-center justify-between px-[1.6rem] py-[1.2rem]">
            <div>
              <Button
                leadingIcon={<CloseIcon />}
                onClick={dismiss}
                type="text"
                width="fluid"
              />
            </div>

            <h3 className="w-full grow text-center text-[2.4rem] font-semibold">
              Filter
            </h3>

            <div>
              <Button
                type="text"
                text="Reset"
                width="fluid"
                onClick={handleResetFilters}
              />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto">
            <div className="h-full px-[1.6rem]">
              <div className="flex flex-col gap-[1.2rem]">
                <CategoryFilters
                  facet_counts={facet_counts}
                  allBrands={allBrands}
                  categories={categories}
                  filterState={potentialFilterChanges}
                  setFilterState={(newFilters) =>
                    setPotentialFilterChanges(newFilters)
                  }
                  showOEMSection={facet_counts?.brand?.some(
                    (v) => v.value === 'OEM' && v.count > 0
                  )}
                  showSellerType
                  showBootSizes={facet_counts?.category1?.some(
                    (v) => v.value === 'Boots' && v.count > 0
                  )}
                  showShirtSizes={facet_counts?.category?.some(
                    (v) => v.value === 'Riding Gear' && v.count > 0
                  )}
                  showPantSizes={facet_counts?.category?.some(
                    (v) => v.value === 'Riding Gear' && v.count > 0
                  )}
                  hideGender={
                    !facet_counts?.category?.some(
                      (v) => v.value === 'Riding Gear' && v.count > 0
                    )
                  }
                  startAllClosed={false}
                />
              </div>
            </div>
          </div>

          <div className="fixed bottom-0 left-0 right-0 w-full bg-brand-white p-4">
            <Button
              text="Apply"
              type="secondary"
              width="fluid"
              height="small"
              onClick={() => {
                onFiltersChange(potentialFilterChanges);
                dismiss();
              }}
            />
          </div>
        </div>
      </BaseModal>
    </div>
  );
};

export default ProductFilterDrawer;
